import { setHandoffCookie } from '@/utils/handoff'
import TreeView from '@/components/treeview/TreeView.vue'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import Roles from '@/shared/utils/roles'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import FileSelection from '@/views/private/operational/documents/components/folderselection/fileselection.vue'
import { createPopper } from '@popperjs/core'
import { AgGridVue } from 'ag-grid-vue'
import { isEqual } from 'lodash'
import moment from 'moment'
import Annex from '../components/annex/annex.vue'
import Resume from '../components/resume/resume.vue'
import gridMixin from '../mixins/gridMixin'

export default {
  name: 'Spreadsheet',
  mixins: [gridMixin, CompanyMixin, PermissionMixin],
  data () {
    return {
      roles: Roles,
      subsidiaries: null,
      contracts: null,
      showAnnex: false,
      showResume: false,
      subsidiarieInput: null,
      noSubsidiarie: true,
      selectedContractId: null,
      selectedContractModelId: null,
      showPciItensModal: false,
      columnDefs: null,
      pciItemsTree: null,
      pciItens: null,
      filterList: [],
      filterSelected: null
    }
  },
  components: {
    AgGridVue,
    Annex,
    TreeView,
    FileSelection,
    Resume
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      // Verifies if user has a company selected
      if (this.company.id !== null) {
        // Get user company
        // let companyId = this.$store.state.company.company.id

        this.columnDefs = [
          {
            headerName: this.$lang.PCI.DataTable.Contract,
            flex: 3,
            field: 'contract',
            suppressColumnsToolPanel: false,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            type: 'textColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.Creation,
            flex: 1,
            field: 'creation',
            suppressColumnsToolPanel: false,
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.ArchivedWorks,
            flex: 1,
            field: 'archivedWorks',
            suppressColumnsToolPanel: false,
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.UserArchivedWorks,
            flex: 1,
            suppressColumnsToolPanel: false,
            field: 'userArchivedWorks'
          },
          {
            headerName: this.$lang.PCI.DataTable.ArchivedFinance,
            flex: 1,
            field: 'archivedFinance',
            suppressColumnsToolPanel: false,
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.UserArchivedFinance,
            flex: 1,
            suppressColumnsToolPanel: false,
            field: 'userArchivedFinance'
          }
        ]

        // Search by subsidiarie contracts
        loading.push()
        PCIRepository.GetPCIs(this.company.id)
          .then(response => {
            // Verifies response status code
            if (response.data.code > 0) {
              // Stores only relevant data to render in grid
              let contracts = response.data.data.map(contract => {
                return {
                  contract: contract.descricao,
                  type: contract.descricaoModelo,
                  creation: contract.criacaoPCI,
                  archivedWorks: contract.arquivamentoPCI,
                  archivedFinance: contract.arquivamentoFinanceiroPCI,
                  userArchivedWorks: contract.usuarioArquivPCI,
                  userArchivedFinance: contract.usuarioArquivFinancPCI,
                  contractId: contract.contratoID,
                  pciId: contract.pciid
                }
              })

              // Set global contracts to local contracts
              this.contracts = contracts
            } else {
              toast.error(this.$lang.Common.CouldNotLoadRegister)
            }
          })
          .finally(() => loading.close())
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          })
      }
    },
    onShowAnnex () {
      this.showAnnex = true

      // Get selected contract row
      let contracts = this.gridOptions.api.getSelectedRows().length > 0 ? this.gridOptions.api.getSelectedRows() : this.contracts
      // let modContracts = contracts.reduce((acc, value) => {
      //   value.contratoId = value.contractId
      //   return value
      // }, [])

      const modContracts = contracts.reduce((acc, value) => {
        if (acc.length === 0 || acc.filter(v => v.referenciaContrato === value.referenciaContrato).length === 0) {
          value.referenciaContrato = value.contract
          value.contratoId = value.contractId
          value.pciId = value.pciId
          acc.push(value)
        }

        return acc
      }, [])

      this.$nextTick(() => {
        this.$refs.annex.show(modContracts)
      })
    },
    onShowResume () {
      if (this.gridOptions.api.getSelectedRows().length) {
        this.showResume = true
        this.$nextTick(() => {
          this.$refs.resume.show(this.gridOptions.api.getSelectedRows().map(p => p.pciId))
        })
      }
    },
    // Select a contract to edit
    selectContract () {
      // Get selected contract row
      let contracts = this.gridOptions.api.getSelectedRows().length ? this.gridOptions.api.getSelectedRows() : null

      // Verifies if the user was selected some contract
      if (contracts !== null) {
        // Set global contract id
        let pciId = contracts.map(contract => contract.pciId)
        // let refs = contracts.map(contract => contract.contract)

        // Verifies if more than 30 contracts was selected
        // if (pciId.length > 30) {
        //   // Remove extra pcis from pciId
        //   while (pciId.length > 30) {
        //     pciId.pop()
        //   }
        // }

        const paramId = 'pciid-' + Math.random().toString(36).substr(2, 16)

        let resolvedRoute = this.$router.resolve({
          name: 'PCI',
          query: {
            paramId: paramId,
            pciAllColumns: this.pciAllColumns
          }
        })

        window.localStorage.setItem(paramId, JSON.stringify(pciId))

        // Quem chegou pelo SSO do ZSistemas (authsso, `origem=sso`) fica na mesma aba; pelo menu do
        // zcloud continua abrindo aba nova.
        if (this.$route.query.origem === 'sso') {
          this.$router.push(resolvedRoute.location)
          return
        }

        setHandoffCookie(JSON.stringify(this.company))
        window.open(resolvedRoute.href, '_blank')
      }
    },
    onFilterChanged (params) {
      if (params.api.isAnyFilterPresent()) {
        let filterText = ''
        const filterModel = params.api.getFilterModel()

        let sepInside = ''
        Object.keys(filterModel).forEach(field => {
          const colDef = params.api.getColumnDef(field)
          const fieldHeader = `[${colDef.headerName}]`

          const processFilter = (filter) => {
            if (filter === null) return
            if (filter.filterType === 'set') {
              let values = filter.values
              if (colDef.type === 'dateColumn') {
                values = filter.values.map(dt => {
                  const date = dt ? moment(dt).toDate().toLocaleDateString() : ''
                  return date
                })
              }
              filterText += ` ${sepInside}${fieldHeader} ${'(' + values.join(', ') + ')'} `
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            } else if (filter.operator) {
              sepInside = '('
              processFilter(filter.condition1)
              sepInside = ` ${this.$lang.AGGrid[filter.operator.toLowerCase() + 'Condition']} `
              processFilter(filter.condition2)
              filterText += ')'
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            } else {
              let condType = this.$lang.AGGrid[filter.type]
              let condFilter
              if (filter.type === 'blank' || filter.type === 'notBlank') {
                condFilter = ''
                condType = filter.type
              } else if (filter.filterType === 'date') {
                const dateFrom = filter.dateFrom ? moment(filter.dateFrom).toDate().toLocaleDateString() : ''
                condFilter = `"${dateFrom}"`
              } else {
                condFilter = `"${filter.filter}"`
              }
              filterText += ` ${sepInside}${fieldHeader} ${condType} ${condFilter} `
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            }
          }

          if (filterModel[field].filterType === 'multi') {
            filterModel[field].filterModels.forEach(filter => {
              processFilter(filter)
            })
          } else {
            const filter = filterModel[field]
            processFilter(filter)
          }
        })

        const filterObj = {label: filterText, filter: filterModel}
        if (!this.filterList.some(obj => {
          return isEqual(obj.filter, filterObj.filter)
        })) {
          this.filterList.push(filterObj)
        }
        this.filterSelected = filterObj
      } else {
        this.filterText = null
        this.filterSelected = null
      }
    },
    onChangeFilter (params) {
      this.gridOptions.api.setFilterModel(params ? params.filter : null)
    },
    withPopper (dropdownList, component, { width }) {
      dropdownList.style.width = width

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'spreadsheet-toggleClass',
            enabled: true,
            phase: 'write',
            fn ({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/spreadsheet/spreadsheet.js